module.exports = __webpack_public_path__ + "images/shop/favicon-carpardoo/safari-pinned-tab.svg";